import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PackagegoodsApi } from '../repository/packagegoods/packagegoods.api';
import { IPackagegoods } from '../repository/packagegoods/packagegoods.model';
import { BrandService } from '../services/brand.service';
import { StateItem } from '../state-item';

@Injectable()
export class PackagegoodsBookingListStateItem extends StateItem<
  IPackagegoods[]
> {
  private readonly packagegoodsApi = inject(PackagegoodsApi);

  private readonly brandService = inject(BrandService);

  constructor() {
    super([]);
  }

  loadPackagegoods(): void {
    this.packagegoodsApi
      .findBookingList({
        brandId: this.brandService.brand.id,
        sort: 'sort',
      })
      .subscribe((list) => {
        this.setValue(list);
      });
  }

  get list$(): Observable<IPackagegoods[]> {
    return this.value$;
  }

  get list(): IPackagegoods[] {
    return this.value;
  }
}
